import { render, staticRenderFns } from "./SearchByProduct.vue?vue&type=template&id=72bab0d0"
import script from "./SearchByProduct.vue?vue&type=script&lang=js"
export * from "./SearchByProduct.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports